import { Component, OnInit } from '@angular/core';
import { FAQ } from 'src/models/faq.model';
import { FAQService } from 'src/services/faq.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css']
})
export class FaqsComponent implements OnInit {

  faq:FAQ;
  faqResponse :string; 
  SiteKey:string="6Leum_YUAAAAAMSgsbl3EEs90b5dkKuZU_2syoDt";

  constructor(private faqService:FAQService) {
    this.faq=new FAQ();
   }

  ngOnInit() {
  }
  Captcha:any='';
  ReserveCaptchaResponse(captchaResponse: string) {
    this.Captcha='';
    this.Captcha = captchaResponse;
    console.log(`Resolved response token: ${captchaResponse}`);
  } 


  onClickSubmit(faqData) { 
    debugger;
    this.faqResponse = '';
    if (!this.faq.Name)
    {
      this.faqResponse = "Enter The Name.";
      return;
    }
    if (!this.faq.Email)
    {
      this.faqResponse = "Enter The Email.";
      return;
    }
    if (!this.faq.Subject) {
      this.faqResponse = "Enter The Subject";
      return;
    }
    if (!this.faq.Message) {
      this.faqResponse = "Enter The Message";
      return;
    }
    // if (!this.faq.Captcha) {
    //   this.faqResponse = "Please verify you are humann!";
    //   return;
    // }
    console.log(this.faq);
    this.faqService.Save(this.faq).subscribe(
      data => {
        var result = data;
        console.log(data);
        grecaptcha.reset(2);
        this.faqResponse ="Your request has been submitted. Our executive will call you soon.";
        this.faq =new FAQ();
      },
      error => {        
        console.log(error);
      }
    ); 
        
 }


onCaptchaClick(captchaResponse: string) {
  this.faq.Captcha = captchaResponse;
  //console.log(`Resolved response token: ${captchaResponse}`);   
}

}
